import React from 'react';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Loader from '../Loader'
import HomeIcon from '@material-ui/icons/Home';
import Avatar from '@material-ui/core/Avatar';
import { auth } from "../config/fire";
import Graph from './Graph'
import Admin from './Admin'
import NewAdmin from './New Admin'
import Users from './Users';
import SMCUsers from './SMCUsers';
import BlogForm from './BlogForm'

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`admin-tabpanel-${index}`}
            aria-labelledby={`admin-tab-${index}`}
            className="admin-tabpanel"
        >
            {value === index && (
                <div>{children}</div>
            )}
        </div>
    );
}

function Dashboard(props) {

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    if (props.uid != null && (props.uid === "w3u78z3dj9ShUtM4DUSRwunUlTw2" || props.uid === "ERW6W79Tc2W4X505adIHBGKRH7t1" || props.uid === "kSwelLNvPSauO9yjZsQZv19uqcH2"))
        return (
            <div>
                <Loader />
                <Grid container style={{ display: 'inline-flex', backgroundColor: 'cornflowerblue' }}>
                    <Grid item xs={6} style={{ alignSelf: 'center', display: 'inline-flex' }}>
                        <h3 className="name" style={{ float: 'left', color: 'white' }}>Welcome {props.name.substr(0, props.name.indexOf(' '))}</h3>
                    </Grid>
                    <Grid item xs={6} className="logout" style={{ alignSelf: 'center' }}>
                        <div style={{ float: 'right', display: 'inline-flex' }}>
                            <Avatar style={{ marginRight: '10px' }} alt={props.name} src={props.photoURL || "https://res.cloudinary.com/dqcsk8rsc/image/upload/v1577268053/avatar-1-bitmoji_upgwhc.png"} />
                            <Button onClick={() => { auth.signOut() }} size="small" variant="contained" color="primary">Logout</Button>
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <div style={{ padding: '15px', marginBottom: '30px' }}>
                            <Button
                                style={{ float: 'right' }}
                                variant="contained"
                                color="primary"
                                href="/"
                                startIcon={<HomeIcon />}
                            >
                                Go to Home</Button>
                        </div>
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={12} style={{ padding: '20px' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="admin-tabs" className="admin-tabs" >
                            <Tab label="All Attempts" />
                            <Tab label="Visualization" />
                            <Tab label="User Management" />
                            <Tab label="SMC User Management" />
                            <Tab label="Add Blog" />
                            <Tab label="Attempts By User" />
                        </Tabs>

                        <TabPanel value={value} index={0}>
                            <Admin />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Graph />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Users />
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <SMCUsers />
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <BlogForm />
                        </TabPanel>
                        <TabPanel value={value} index={5}>
                            <NewAdmin />
                        </TabPanel>
                    </Grid>
                </Grid>
            </div>
        )
    else
        return (
            <div>
                <Loader />
                You're not an admin
            </div >
        )
}

export default Dashboard;